import { useAuth0 } from '@auth0/auth0-react';
import { Avatar, IconButton, Menu, MenuItem, Skeleton, Stack, Typography, useTheme } from '@mui/material';
import { useState, MouseEvent } from 'react';
import { loginConfig } from '../utils/loginConfig';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Trans } from '@lingui/react/macro';

export const UserMenu = () => {
  const { user, isLoading, loginWithRedirect, logout } = useAuth0();
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleLogout = () => {
    logout();
    handleClose();
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  if (isLoading) {
    return (
      <Stack direction="row" gap={2} alignItems="center" height="100%" p={2}>
        <Skeleton variant="rounded" width={48} height={48} />
        <Skeleton variant="text" sx={{ flex: 1 }} />
        <IconButton
          id="user-menu-button"
          aria-controls={open ? 'user-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          sx={{ borderRadius: '6px', border: `1px solid ${theme.palette.grey[200]}` }}
        >
          <ExpandMoreIcon />
        </IconButton>
        <Menu
          id="user-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'user-menu-button',
          }}
        >
          <MenuItem onClick={handleLogout}>
            <Trans>Logout</Trans>
          </MenuItem>
        </Menu>
      </Stack>
    );
  }

  if (!user) {
    loginWithRedirect(loginConfig(window.location.pathname));
    return (
      <Stack direction="row" gap={2} alignItems="center" height="100%" p={2}>
        <Skeleton variant="rounded" width={48} height={48} />
        <Skeleton variant="text" sx={{ flex: 1 }} />
        <IconButton
          id="user-menu-button"
          aria-controls={open ? 'user-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          sx={{ borderRadius: '6px', border: `1px solid ${theme.palette.grey[200]}` }}
        >
          <ExpandMoreIcon />
        </IconButton>
        <Menu
          id="user-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'user-menu-button',
          }}
        >
          <MenuItem onClick={handleLogout}>
            <Trans>Logout</Trans>
          </MenuItem>
        </Menu>
      </Stack>
    );
  }

  return (
    <Stack direction="row" gap={2} alignItems="center" height="100%" p={2}>
      <Avatar src="/broken-image.jpg" sx={{ borderRadius: '6px', border: `1px solid ${theme.palette.grey[200]}`, width: '48px', height: '48px' }} />
      <Typography sx={{ flex: 1, textOverflow: 'ellipsis', overflow: 'hidden' }}>{user.name}</Typography>
      <IconButton
        id="user-menu-button"
        aria-controls={open ? 'user-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        sx={{ borderRadius: '6px', border: `1px solid ${theme.palette.grey[200]}` }}
      >
        <ExpandMoreIcon />
      </IconButton>
      <Menu
        id="user-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'user-menu-button',
        }}
      >
        <MenuItem onClick={handleLogout}>
          <Trans>Logout</Trans>
        </MenuItem>
      </Menu>
    </Stack>
  );
};
